export const getElementById = (array, id)  => {
    let cs = array.filter((elm) => Number(elm.id) === Number(id));

    if (cs.length > 0)
      return cs[0];

    return null;
}

export const parseLicenseJson = (data) => {
  if (data == null)
    return ""

  try {
    const jsonData = JSON.parse(data)

    const parts = [
      jsonData.countries?.map(e => e?.name).filter(Boolean).join(', '),
      jsonData.educationLevels?.map(e => e?.description || e?.name).filter(Boolean).join(', '),
      jsonData.lessonGroups?.map(e => e?.name).filter(Boolean).join(', '),
      jsonData.num_licenses ? `Licenze: ${jsonData.num_licenses}` : null,
      jsonData.expiration_date ? `Scadenza: ${jsonData.expiration_date}` : null,
    ].filter(Boolean);

    return parts.join(' - ');
  } catch {
    return ""
  }
}